import { ReactNode } from "react";
import { Role } from "../context/userinfo/types";
import { useUserInfo } from "../context/userinfo/useUserInfo";
import { ConditionalRenderer } from "../utils/helpers";
import { isAuthorisedRole } from "../utils/utils";

type RBACRoleObject = {
  default: Role[];
  [tenant: string]: Role[];
};
interface AccessRole {
  role: RBACRoleObject;
  resource: string;
}

type AccessRolesArray = AccessRole[];

//resource format: {FileName}.{Section/ Subsection - to be hidden behind roles}
const accessRolesArray: AccessRolesArray = [
  {
    role: {
      default: [
        Role.OPERATIONS,
        Role.TENANT_ORDER_OPERATIONS,
        Role.CYBRILLA_ADMIN,
        Role.TENANT_ROOT,
      ],
      axismf: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },
    resource: "OrderOperations.Actions",
  },
  {
    role: {
      default: [
        Role.OPERATIONS,
        Role.TENANT_ORDER_OPERATIONS,
        Role.CYBRILLA_ADMIN,
        Role.TENANT_ROOT,
      ],
      axismf: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },
    resource: "DepositoryFilesUpload.ViewUploadedFiles",
  },
  {
    role: {
      default: [
        Role.OPERATIONS,
        Role.TENANT_ORDER_OPERATIONS,
        Role.CYBRILLA_ADMIN,
        Role.TENANT_ROOT,
        Role.OPERATIONS_ANALYST,
      ],
      axismf: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },
    resource: "UploadFolioFeeds.ViewUploadedFiles",
  },
  {
    role: {
      default: [
        Role.OPERATIONS,
        Role.TENANT_ORDER_OPERATIONS,
        Role.CYBRILLA_ADMIN,
        Role.TENANT_ROOT,
        Role.OPERATIONS_ANALYST,
      ],
      axismf: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },

    resource: "Cams.ViewUploadedFiles",
  },
  {
    role: {
      default: [
        Role.OPERATIONS,
        Role.TENANT_ORDER_OPERATIONS,
        Role.CYBRILLA_ADMIN,
        Role.TENANT_ROOT,
        Role.OPERATIONS_ANALYST,
      ],
      axismf: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },

    resource: "Kfin.ViewUploadedFiles",
  },
  {
    role: {
      default: [
        Role.OPERATIONS,
        Role.TENANT_ORDER_OPERATIONS,
        Role.CYBRILLA_ADMIN,
        Role.TENANT_ROOT,
      ],
      axismf: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },
    resource: "UploadFailedOrderFeeds.ViewUploadedFiles",
  },
  {
    role: {
      default: [
        Role.OPERATIONS,
        Role.TENANT_ORDER_OPERATIONS,
        Role.CYBRILLA_ADMIN,
        Role.TENANT_ROOT,
      ],
      axismf: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },
    resource: "UploadNigoFeeds.ViewUploadedFiles",
  },
  {
    role: {
      default: [
        Role.OPERATIONS,
        Role.TENANT_ORDER_OPERATIONS,
        Role.CYBRILLA_ADMIN,
        Role.TENANT_ROOT,
        Role.OPERATIONS_ANALYST,
      ],
      axismf: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },
    resource: "UploadReverseFeeds.ViewUploadedFiles",
  },
  {
    role: {
      default: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },
    resource: "OrderOperationsDownload.OrderFeedDownload",
  },
  {
    role: {
      default: [
        Role.OPERATIONS,
        Role.TENANT_ORDER_OPERATIONS,
        Role.CYBRILLA_ADMIN,
        Role.TENANT_ROOT,
      ],
      axismf: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },
    resource: "OrderOperationsDownload.InvestorFilesDownload",
  },
  {
    role: {
      default: [
        Role.OPERATIONS,
        Role.TENANT_ORDER_OPERATIONS,
        Role.CYBRILLA_ADMIN,
        Role.TENANT_ROOT,
        Role.OPERATIONS_ANALYST,
      ],
      axismf: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },
    resource: "OrderOperationsUpload.UploadReverseFeeds",
  },
  {
    role: {
      default: [
        Role.OPERATIONS,
        Role.TENANT_ORDER_OPERATIONS,
        Role.CYBRILLA_ADMIN,
        Role.TENANT_ROOT,
      ],
      axismf: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },
    resource: "OrderOperationsUpload.UploadNigoFeeds",
  },
  {
    role: {
      default: [
        Role.OPERATIONS,
        Role.TENANT_ORDER_OPERATIONS,
        Role.CYBRILLA_ADMIN,
        Role.TENANT_ROOT,
        Role.OPERATIONS_ANALYST,
      ],
      axismf: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },
    resource: "OrderOperationsUpload.UploadReverseFeedsPOA",
  },
  {
    role: {
      default: [
        Role.OPERATIONS,
        Role.TENANT_ORDER_OPERATIONS,
        Role.CYBRILLA_ADMIN,
        Role.TENANT_ROOT,
      ],
      axismf: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
    },
    resource: "OrderOperationsUpload.DepositoryFilesUpload",
  },
  {
    role: {
      default: [Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN, Role.TENANT_ROOT],
      axismf: [Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN],
    },
    resource: "SettlementDetails.ApiLogsLink",
  },
  {
    role: {
      default: [
        Role.CYBRILLA_ADMIN,
        Role.CUSTOMER_SUCCESS,
        Role.OPERATIONS,
        Role.TENANT_ROOT,
        Role.TENANT_WORKFORCE,
      ],
      axismf: [Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS, Role.OPERATIONS],
    },
    resource: "PartnersListing.Actions",
  },
  {
    role: {
      default: [
        Role.CYBRILLA_ADMIN,
        Role.CUSTOMER_SUCCESS,
        Role.OPERATIONS,
        Role.TENANT_OPERATIONS,
        Role.TENANT_ROOT,
        Role.TENANT_WORKFORCE,
      ],
      axismf: [
        Role.CYBRILLA_ADMIN,
        Role.CUSTOMER_SUCCESS,
        Role.OPERATIONS,
        Role.TENANT_OPERATIONS,
        Role.TENANT_WORKFORCE,
      ],
    },
    resource: "routeHelpers.ProtectedExternalLink",
  },
  {
    role: {
      default: [
        Role.THIRDEYE_MANAGER,
        Role.THIRDEYE_ANALYST,
        Role.THIRDEYE_OPERATIONS,
        Role.THIRDEYE_SQLLAB,
      ],
    },
    resource: "routeHelpers.ProtectedExternalLinkButton",
  },
  {
    role: {
      default: [
        Role.CUSTOMER_SUCCESS,
        Role.TENANT_MEMBERSHIP_OPERATION,
        Role.TENANT_MEMBERSHIP_CHECKER,
        Role.TENANT_MEMBERSHIP_REVIEWER,
        Role.TENANT_MEMBERSHIP_APPROVER,
        Role.TENANT_MEMBERSHIP_MD,
        Role.CYBRILLA_ADMIN,
      ],
    },
    resource: "NavItems.MembershipPortalLink",
  },
  {
    role: {
      default: [
        Role.CYBRILLA_ADMIN,
        Role.CUSTOMER_SUCCESS,
        Role.OPERATIONS,
        Role.TENANT_OPERATIONS,
        Role.TENANT_ROOT,
        Role.TENANT_WORKFORCE,
        Role.TENANT_MEMBERSHIP_OPERATION,
        Role.TENANT_MEMBERSHIP_CHECKER,
        Role.TENANT_MEMBERSHIP_REVIEWER,
        Role.TENANT_MEMBERSHIP_APPROVER,
        Role.TENANT_MEMBERSHIP_MD,
        Role.THIRDEYE_MANAGER,
        Role.THIRDEYE_ANALYST,
        Role.THIRDEYE_OPERATIONS,
        Role.THIRDEYE_SQLLAB,
      ],
      axismf: [
        Role.CYBRILLA_ADMIN,
        Role.CUSTOMER_SUCCESS,
        Role.OPERATIONS,
        Role.TENANT_OPERATIONS,
        Role.TENANT_WORKFORCE,
        Role.THIRDEYE_MANAGER,
        Role.THIRDEYE_ANALYST,
        Role.THIRDEYE_OPERATIONS,
        Role.THIRDEYE_SQLLAB,
      ],
    },
    resource: "NavItems.ProtectedExternalApplicationsTitle",
  },
  {
    role: {
      default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.CUSTOMER_SUCCESS],
    },
    resource: "PaymentsGatewayService.BankSettings",
  },
  {
    role: {
      default: [Role.CUSTOMER_SUCCESS, Role.OPERATIONS, Role.CYBRILLA_ADMIN, Role.TENANT_ROOT],
    },
    resource: "Purchases.Payments",
  },
  {
    role: {
      default: [Role.TENANT_ASSOCIATE_WORKFORCE, Role.TENANT_WORKFORCE],
    },
    resource: "Purchase.PaymentsWorkforce",
  },
  {
    role: {
      default: [Role.CUSTOMER_SUCCESS, Role.OPERATIONS, Role.CYBRILLA_ADMIN, Role.TENANT_ROOT],
    },
    resource: "PurchasePlans.PaymentSource",
  },
  {
    role: {
      default: [Role.TENANT_ASSOCIATE_WORKFORCE, Role.TENANT_WORKFORCE],
    },
    resource: "PurchasePlans.PaymentSourceWorkforce",
  },
  {
    role: {
      default: [Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS, Role.OPERATIONS],
    },
    resource: "PartnerCredentials.MainDiv",
  },
  {
    role: {
      default: [Role.CYBRILLA_ADMIN],
    },
    resource: "PartnerCredentials.GenerateCredentials",
  },
  {
    role: {
      default: [Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS],
    },
    resource: "PartnersDetails.PartnerConfiguration",
  },
  {
    role: {
      default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS],
    },
    resource: "OrderOperationsUpload.AumReconciliationFeedUpload",
  },
];

function getRolesForResource(resource: string, activeTenant: string): Role[] {
  const entry = accessRolesArray?.find((item) => item.resource === resource);
  if (!entry) return [];

  return entry?.role[activeTenant] ?? entry?.role.default;
}

export const RenderByUserRole = ({
  resource,
  children,
}: {
  readonly resource: string;
  readonly children: ReactNode;
}) => {
  const userInfo = useUserInfo();

  const currentRoles = userInfo?.data.userInfo?.roles;
  const activeTenant = userInfo?.data.activeTenant;

  if (!resource || !currentRoles || !activeTenant) {
    return null;
  }

  const allowedRoles = getRolesForResource(resource, activeTenant);

  return (
    <ConditionalRenderer check={isAuthorisedRole(allowedRoles, currentRoles)}>
      {children}
    </ConditionalRenderer>
  );
};
